define('ZipCodeSession.Model', [
  'underscore',
  'Utils',
  'SCModel'
], function ZipCodeSessionModelModule(_, Utils, SCModelComponent) {
  'use strict';

  var SCModel = SCModelComponent.SCModel;

  function ZipCodeSessionModel(attributes, options) {
    SCModel.call(this, attributes, options);

    this.urlRoot = function urlRoot() {
      return Utils.getAbsoluteUrl(getExtensionAssetsPath('services/ZipCodeSession.Service.ss'));
    };
  }

  ZipCodeSessionModel.prototype = Object.create(SCModel.prototype);

  _.extend(ZipCodeSessionModel.prototype, {
    constructor: ZipCodeSessionModel,

    getZipCode: function getZipCode() {
      return this.get('zipCode');
    },

    setZipCode: function setZipCode(zipCode) {
      this.set('zipCode', zipCode);
    }
  });

  return ZipCodeSessionModel;
});
